//#region components/rich_text_editor/rich_text_editor_constants.js
var e = [
	"text",
	"json",
	"html",
	"markdown"
], t = [
	"start",
	"end",
	"all"
], n = [
	"https",
	"http",
	"ftp",
	"ftps",
	"sftp",
	"mailto"
], r = {
	RICH_TEXT_EDITOR_SUPPORTED_LINK_PROTOCOLS: n,
	RICH_TEXT_EDITOR_OUTPUT_FORMATS: e,
	RICH_TEXT_EDITOR_AUTOFOCUS_TYPES: t
};
//#endregion
export { t as RICH_TEXT_EDITOR_AUTOFOCUS_TYPES, e as RICH_TEXT_EDITOR_OUTPUT_FORMATS, n as RICH_TEXT_EDITOR_SUPPORTED_LINK_PROTOCOLS, r as default };

//# sourceMappingURL=rich-text-editor-constants.js.map